import { config } from '../sitemap/sitemap-config';

/**
 * Generates hreflang
 *
 * e.g. en-no
 * The first part “en” is for English language and the second one, “no”, is for target country.
 * if have a version for Norway that is written in English, hence “en-no”
 * @param lang
 * @returns string
 */
export function formatLang(lang: string) {
    const country = config.marketToCountry[lang];
    const language = config.marketToLanguage[lang] ?? 'en';
    return `${language}-${country.toLowerCase()}`;
}

export function formatLangV2(country: string | null, language: string): string {
    if (country === null) {
        return language.toLowerCase();
    } else {
        return `${language}-${country}`.toLowerCase();
    }
}
